// src/components/dashboard/stats/CircularProgressIndicator.tsx
// ✅ CORRIGIDO: NaN% quando não há cards estudados

import React, { useEffect, useRef, useState } from 'react';

interface Props {
    cardsStudied: number;
    cardsMastered: number;
    totalCards: number;
    animate: boolean;
}

const RADIUS_OUTER = 70;
const RADIUS_INNER = 58;
const CIRCUMFERENCE_OUTER = 2 * Math.PI * RADIUS_OUTER;
const CIRCUMFERENCE_INNER = 2 * Math.PI * RADIUS_INNER;

const CircularProgressIndicator: React.FC<Props> = ({
    cardsStudied,
    cardsMastered,
    totalCards,
    animate
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(false);

    // ✅ CORREÇÃO: Evitar divisão por zero
    const masteredPercent = totalCards > 0
        ? Math.min(cardsMastered / totalCards, 1)
        : 0;

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.4 }
        );

        if (ref.current) observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    const outerOffset = visible
        ? 0
        : CIRCUMFERENCE_OUTER;

    const innerOffset = visible
        ? CIRCUMFERENCE_INNER * (1 - masteredPercent)
        : CIRCUMFERENCE_INNER;

    return (
        <div className="dsb-estx-hj-circular" ref={ref}>
            <h3>Progresso de domínio</h3>

            <div className="dsb-estx-hj-circular-container">
                <svg className="dsb-estx-hj-circular-svg" viewBox="0 0 160 160">
                    {/* Fundo */}
                    <circle
                        cx="80"
                        cy="80"
                        r={RADIUS_OUTER}
                        className="dsb-estx-hj-circular-bg"
                    />

                    {/* Círculo externo — sempre 100% */}
                    <circle
                        cx="80"
                        cy="80"
                        r={RADIUS_OUTER}
                        className="dsb-estx-hj-circular-outer"
                        strokeDasharray={CIRCUMFERENCE_OUTER}
                        strokeDashoffset={outerOffset}
                    />

                    {/* Círculo interno — progresso real */}
                    <circle
                        cx="80"
                        cy="80"
                        r={RADIUS_INNER}
                        className="dsb-estx-hj-circular-inner"
                        strokeDasharray={CIRCUMFERENCE_INNER}
                        strokeDashoffset={innerOffset}
                    />
                </svg>

                <div className="dsb-estx-hj-circular-text">
                    <div className="dsb-estx-hj-circular-value">
                        {(masteredPercent * 100).toFixed(0)}%
                    </div>
                    <div className="dsb-estx-hj-circular-sub">
                        Cards dominados
                    </div>
                </div>
            </div>
            <div className="dsb-estx-hj-circular-legend">
                <div className="dsb-estx-hj-legend-item">
                    <div className="dsb-estx-hj-legend-color outer"></div>
                    <span>{cardsStudied} estudados</span>
                </div>
                <div className="dsb-estx-hj-legend-item">
                    <div className="dsb-estx-hj-legend-color inner"></div>
                    <span>{cardsMastered} dominados</span>
                </div>
            </div>
        </div>
    );
};

export default CircularProgressIndicator;